import { Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { JobLevelGridViewModel, JobLevelViewModel } from '../models/generated-view-models';
import { URLS } from '../shared/url';
import { ResponseTypeEnum } from '../models/enums';

@Injectable({
  providedIn: 'root'
})
export class JobLevelService {

    constructor(private http: BaseHttpService) { }

    public getJobLevelList = (): Observable<JobLevelGridViewModel[]> => {
        return this.http.Get(URLS.getJobLevelList);
    }

    public getJobLevel = (jobLevelId: number): Observable<JobLevelViewModel> => {
        return this.http.Get(`${URLS.getJobLevel}/${jobLevelId}`);
    }

    public saveJobLevel = (jobLevel: JobLevelViewModel): Observable<boolean> => {
        return this.http.Post(URLS.saveJobLevel, jobLevel, ResponseTypeEnum.Success);
    }

    public deleteJobLevel = (jobLevelId: number): Observable<boolean> => {
        return this.http.Delete(`${URLS.deleteJobLevel}/${jobLevelId}`, ResponseTypeEnum.Success);
    }
}
